import { Fragment } from 'react'
import './SectionItemContainer.scss'
import { LuxButton } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'

const SectionItemContainer = (props) => {
    const componentClass = 'smart-new-activity-section-item-container'
    const intl = useIntl()

    return (
        <div className={componentClass}>
            {props.children}
            {!props.hideFooter && <div className={`${componentClass}__footer`}>
                <div className={`${componentClass}__cta-container`}>
                    {props.ctaTemplate}
                    {!props.ctaTemplate && (
                        <Fragment>
                            <div className="link-mini" onClick={props.onClear}>
                                {intl.formatMessage({
                                    id: 'modals.new.activity.section.clear',
                                    defaultMessage: 'clear',
                                })}
                            </div>
                            <LuxButton
                                onClick={props.onSave}
                                text={intl.formatMessage({
                                    id: 'modals.new.activity.section.save',
                                    defaultMessage: 'save',
                                })}
                                disabled={!props.isDone}
                            />
                        </Fragment>
                    )}
                </div>
            </div>}
        </div>
    )
}

export default SectionItemContainer
